import { delay, fork, select } from "redux-saga/effects";
import { call, put } from "redux-saga/effects";
import { selectUser } from "../../features/auth/authSlice";
import { User } from "../../types/User";
import { Host } from "../../types/Host";
import {
  setError as setDashError,
  setStatus as setDashStatus,
  setHosts,
} from "../../features/library/librarySlice";
import * as actions from "../actions";

import {
  apiCreateHost,
  apiGetHosts,
  apiResetHostPassword,
  apiUpdateHost,
} from "../../services/HostAPI";

export function* createHost(
  action: ReturnType<typeof actions.createHost>
  ) {
  yield put(setDashStatus({ status: "loading", error: undefined }));
  
  try {
    const userState = (yield select(selectUser)) as User;
    const createResponse = yield call(
      apiCreateHost,
      userState.default_organization_id,
      userState.default_workspace_id,
      action.payload
    );
  
    yield put(actions.getHosts());

  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* getHosts(
  action: ReturnType<typeof actions.getRoles>
  ) {
  yield put(setDashStatus({ status: "loading", error: undefined }));
  
  try {
    const userState = (yield select(selectUser)) as User;
    const response = yield call(
      apiGetHosts,
      userState.default_organization_id,
      userState.default_workspace_id
    );

    //console.log("XXX", response.data);

    yield put(setHosts(response.data.hosts));
  
    yield put(setDashStatus({ status: "idle", error: undefined }));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* updateHost(
  action: ReturnType<typeof actions.updateHost>
  ) {
  yield put(setDashStatus({ status: "loading", error: undefined }));
  
  try {
    const userState = (yield select(selectUser)) as User;
    const updateResponse = yield call(
      apiUpdateHost,
      userState.default_organization_id,
      userState.default_workspace_id,
      action.payload.hostId,
      action.payload.hostUpdateRequest
    );
  
    yield put(actions.getHosts());

  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* resetHostPassword(
  action: ReturnType<typeof actions.resetHostPassword>
  ) {
  yield put(setDashStatus({ status: "loading", error: undefined }));
  
  try {
    const userState = (yield select(selectUser)) as User;
    const resetResponse = yield call(
      apiResetHostPassword,
      userState.default_organization_id,
      userState.default_workspace_id,
      action.payload.hostId,
      action.payload.hostPasswordResetRequest
    );
  
    yield put(actions.getHosts());

  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}